// angular
import {CommonModule} from "@angular/common";
import {Component, input, output} from "@angular/core";
// material angular
import {MatButtonModule} from "@angular/material/button";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

type COLOR =
  | "primary-main"
  | "primary-dark"
  | "primary-light"
  | "secondary"
  | "danger";
type VARIANT = "filled" | "outlined" | "text";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
})
export class ButtonComponent {
  // inputs
  color = input<COLOR>("primary-main");
  size = input<"small" | "medium" | "large">("medium");
  variant = input<VARIANT>("filled");
  disabled = input<boolean>(false);
  isLoading = input<boolean>(false);
  buttonClasses = input<string>();

  // outputs
  clicked = output<MouseEvent>();

  handleClick(event: MouseEvent) {
    this.clicked.emit(event);
  }
}
